import { createStore } from '@'

export const $users = createStore('flight:users')
export const $tableData = createStore('flight:tableData')
export const $expandedRows = createStore('flight:expandedRows')
export const $filter = createStore('flight:filter')
